import { render } from "./AdminUserPage.vue?vue&type=template&id=72584f1a&scoped=true"
import script from "./AdminUserPage.vue?vue&type=script&lang=js"
export * from "./AdminUserPage.vue?vue&type=script&lang=js"

import "./AdminUserPage.vue?vue&type=style&index=0&id=72584f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72584f1a"]])

export default __exports__